module.exports = __webpack_public_path__ + "static/media/id.adc702af.png";